import { InjectionToken } from '@angular/core';

export enum FinnairTheme {
  LEGACY = 'legacy',
  LIGHT_THEME = 'light-theme',
  DARK_THEME = 'dark-theme',
}

export const FINNAIR_THEME_COOKIE_NAME = 'finnair-theme';

export const FINNAIR_THEME: InjectionToken<FinnairTheme> = new InjectionToken<FinnairTheme>('FinnairTheme');

export const NEW_BRAND_STYLES_URL: InjectionToken<string> = new InjectionToken<string>('NewBrandStylesUrl');
